export default {"src":"/_next/static/media/left-arrow-nav-dashboard.5a722169.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};